<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <object-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></object-add-form>
                <object-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></object-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import ObjectAddForm from '../components/forms/add/representations/WizardForm'
    import ObjectUpdateForm from '../components/forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../objectStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            ObjectAddForm,
            ObjectUpdateForm
        },

    }
</script>
